import { Publication } from './publication';
import { Categorie } from './categorie';

export class Article extends Publication {

    
    categories: Categorie[];
    editMode: string;
    type_article;


    constructor() {
        super();
    }


}
